module.exports = __webpack_public_path__ + "img/logo.321450b6.svg";